import {
  getBTAddress,
  validateContact,
  isValidChinesePhoneWithCountryCode,
} from "../../utils/addressUtils";

const BillAddress: React.FC<{
  errMsg?: string;
  setErrMsg: (value: string) => void;
  selectedBT: any;
  billContact: string;
  setBillContact: (value: string) => void;
}> = (props) => {
  const { billContact, setBillContact, selectedBT, errMsg, setErrMsg } = props;
  const handleContact = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value);
    setBillContact(e.target.value);
    const res = validateContact(e.target.value);
    if (res?.isValid) {
      const phoneRaw = res.value.split(",")[1] || "";
      const phone = phoneRaw.replace(/[()\uFF08\uFF09]/g, "").trim(); // 去掉中英文括号
      if (phone && !isValidChinesePhoneWithCountryCode(phone)) {
        setErrMsg("注意：您输入的联系方式格式可能不对，若您确认无误，请忽略");
      } else {
        setErrMsg("");
      }
    } else {
      setErrMsg(res?.errMsg || "注意：您输入的联系方式格式可能不对，若您确认无误，请忽略");
    }
  };
  if (!selectedBT) {
    return null;
  }
  let tagClass =
    selectedBT?.addressStatus === "ACTIVE" ? "tag" : "tag warning";
  let tag = selectedBT?.addressStatus === "ACTIVE" ? "" : "待定";
  if (selectedBT?.prePaymentAccount) {
    tag = "预付款账户";
    tagClass = "tag highlight";
  }
  return (
    <div className="card">
      <div className="cardTitle">收票地址</div>
      {selectedBT?.accountNumber && (
        <div className="gap8 subBlock">
          {tag && <span className={tagClass}>{tag}</span>}
          <span className="label">账户</span>
          <span className="text">{selectedBT?.accountNumber}</span>
        </div>
      )}
      {!selectedBT?.accountNumber && (
        <div className="gap8 subBlock">
          <span className="label">web参考号</span>
          <span className="text">{selectedBT?.addressKey}</span>
        </div>
      )}
      <div className="block2 labelTextLine">
        <label className="primaryLabel">收票单位</label>{" "}
        <span className="primaryText">{selectedBT.companyOrInstitution}</span>
      </div>
      <div className="gap12 labelTextLine">
        <label className="primaryLabel">收票地址</label>{" "}
        <span className="primaryText">{getBTAddress(selectedBT)}</span>
      </div>
      <div className="block3">
        <label className="primaryLabel">收票联系人+电话（必填）（格式: 姓名,电话）</label>
      </div>
      <div className="gap8">
        <input
          className={errMsg ? "input err" : "input"}
          value={billContact}
          maxLength={50}
          onChange={handleContact}
        ></input>
      </div>
      <div className="errWrapper">{errMsg || ""}</div>
    </div>
  );
};
export default BillAddress;
